import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ConsoleService } from 'src/app/shared/services/console.service';
import gql from 'graphql-tag';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { ToastService, MDBDatePickerComponent } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { PagoService } from 'src/app/services/pago.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import * as _ from 'lodash';
import { ControlResumidoService } from 'src/app/services/control-resumido.service';
import { CuentaBancariaService } from 'src/app/services/cuenta-bancaria.service';
import { BancoService } from 'src/app/services/banco.service';
import { DatesService } from 'src/app/shared/services/dates.service';

@Component({
  selector: 'app-modal-control-efectivo',
  templateUrl: './modal-control-efectivo.component.html',
  styleUrls: ['./modal-control-efectivo.component.scss'],
  providers: [SecurityService],
})
export class ModalControlEfectivoComponent implements OnInit {
  @ViewChild('controlEfectivo', { static: true }) controlEfectivoModal: ModalDirective;
  @ViewChild('fecha', { static: true }) dtpFecha: MDBDatePickerComponent;


  @Output() onControlEfectivoRealizado: EventEmitter<any> = new EventEmitter<any>();
  @Output() onProcessingChance = new EventEmitter<boolean>();

  readonly TIPO_ABONO: String = `_TIPO_ABONO_`;
  readonly TIPO_CARGO: String = `_TIPO_CARGO_`;

  // Forms
  formRecibidoHeader: FormGroup;
  formRecibidoDepositos: FormGroup;
  optionsBancosEmpresa: Array<any> = [];
  optionsCuentasBancosDeposito;
  listaDepositosRecibidos: Array<any> = [];
  totalDepositosRecibidos: number = 0;
  totalRecibidos: number = 0;
  formDiferencial: FormGroup;
  formCargoRuta: FormGroup;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  private rutUsuario: number;
  resumen: any = null;
  declarante: any = null;
  mainData: any = [];
  processing: boolean = false;

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private usuarioService: UsuarioService,
    private rutService: RutService,
    private bancoService: BancoService,
    private cuentaBancariaService: CuentaBancariaService,
    private pagoService: PagoService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private controlResumidoService: ControlResumidoService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('REALIZAR-PAGOS-CABECERA-MODAL-CONTROL-EFECTIVO');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.getBancosEmpresas();
    this.createForms();
    this.formChangesSubscriptions();
  }

  private getBancosEmpresas() {
    this.bancoService.obtenerBancoEmpresas(this.rutEmpresa, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBancosEmpresa = registros.map((banco) => ({ value: banco.codigo, label: banco.nombre, ...banco }));
    });
  }

  private createForms() {
    this.formRecibidoHeader = this.fb.group({
      efectivo: [0, [Validators.required, Validators.min(0)]],
      dctoTransferencia: [0, [Validators.required, Validators.min(0)]],
      cheque: [0, [Validators.required, Validators.min(0)]],
    });
    this.formRecibidoDepositos = this.fb.group({
      monto: [null, [Validators.required, Validators.min(1)]],
      nroDeposito: [null, [Validators.required, Validators.min(1)]],
      fecha: [null, [Validators.required]],
      banco: [null, [Validators.required]],
      nroCuenta: [null, [Validators.required]],
    });
    this.formDiferencial = this.fb.group({
      cargoOrAbono: [this.TIPO_ABONO, []],
      monto: [0, [Validators.required, Validators.min(1)]],
      motivo: [null, [Validators.required]],
    });
    this.formCargoRuta = this.fb.group({
      monto: [0, [Validators.required, Validators.min(1)]],
      motivo: [null, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formRecibidoHeader.get('efectivo').valueChanges.subscribe((value) => this.calcularTotalesRecibidos());
    this.formRecibidoHeader.get('dctoTransferencia').valueChanges.subscribe((value) => this.calcularTotalesRecibidos());
    this.formRecibidoHeader.get('cheque').valueChanges.subscribe((value) => this.calcularTotalesRecibidos());
    this.formRecibidoDepositos.get('banco').valueChanges.subscribe((banco_codigo) => {
      this.getCuentasDeposito(banco_codigo);
    });
    // this.formDiferencial.get("cargoOrAbono").valueChanges.subscribe(value => this.calcularTotalesRecibidos())
    // this.formDiferencial.get("monto").valueChanges.subscribe(value => this.calcularTotalesRecibidos())
    this.formCargoRuta.get('monto').valueChanges.subscribe((value) => this.calcularTotalesRecibidos());
  }

  getCuentasDeposito(banco_codigo) {
    this.cuentaBancariaService.obtenerCuentaEmpresa(this.rutEmpresa, banco_codigo, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.formRecibidoDepositos.get('nroCuenta').setValue(null);
      this.formRecibidoDepositos.get('nroCuenta').markAsPristine();
      this.formRecibidoDepositos.get('nroCuenta').markAsUntouched();
      this.optionsCuentasBancosDeposito = registros.map((cuenta) => ({ value: cuenta.numero_cuenta, label: cuenta.numero_cuenta, ...cuenta }));
    });
  }

  /********* SHOW/HIDE *********/
  show() {
    this.controlEfectivoModal.show();
  }

  hide() {
    // this.formData.reset()
    this.controlEfectivoModal.hide();
  }
  /********* SHOW/HIDE *********/

  loadData(mainData, declara) {
    // Puede ser tb en ngOnInit, pero lo dejo acá para depurar más fácil
    // this.loadDataDeclarante()

    this.formDiferencial.markAsPristine();
    this.formDiferencial.markAsUntouched();

    this.formCargoRuta.markAsPristine();
    this.formCargoRuta.markAsUntouched();

    this.formRecibidoHeader.markAsPristine();
    this.formRecibidoHeader.markAsUntouched();

    const now = this.datesService.CurrentDateToShortTimeString();
    this.formRecibidoDepositos.get('fecha').setValue(now);
    this.formRecibidoDepositos.markAsPristine();
    this.formRecibidoDepositos.markAsUntouched();

    this.mainData = mainData;
    this.log('mainData', JSON.stringify(mainData));
    const declarante = declara;
    this.loadDataDeclarante(declarante);
  }

  loadDataDeclarante(declara) {
    this.usuarioService.obtenerSegunId(this.rutUsuario, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.declarante = respuesta;
      this.declarante.rutUsuarioFormato = this.rutService.AgregarDV(this.declarante.rut_usuario);

      // this.log('this.mainData.forma_pago', this.mainData.forma_pago)
      // const forma_pago = this.mainData.pagos[0].forma_pago
      // const diferencial_pago = this.mainData.pagos[0].difereciaPago
      // const inputParams = {
      //   entidad: {
      //     empresa_rut: this.rutEmpresa,
      //     sucursal_codigo: this.sucursalEmpresa,
      //     forma_pago: this.mainData.forma_pago, // TODO: Debería aceptar un array
      //     diferencial_pago: this.mainData.diferencial_pago
      //   }
      // }
      const pagos = this.mainData.pagos.map((pago) => ({
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        forma_pago: pago.forma_pago,
        diferencial_pago: pago.diferencial_pago, // Es necesario cuando es por vendedor?
        difereciaPago: pago.difereciaPago,
        monto_coforme: pago.monto_coforme,
      }));
      const inputParams = {
        entidad: {
          pagos,
        },
      };
      this.log('ESTE ES EL MAIN DATA!!', JSON.stringify(this.mainData));
      this.log('ESTE ES EL PAYLOAD!!', JSON.stringify(inputParams));
      this.controlResumidoService.validarControlResume(inputParams, ({ mensajes, respuesta }) => {
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.onProcessingChance.emit(false)
          return;
        }
        this.resumen = respuesta;
        this.setDefaultValues();

        this.listaDepositosRecibidos = respuesta.listaDepositos;
        this.listaDepositosRecibidos.forEach((d, index) => {
          d.index = index;
          delete d.__typename;
        });
        this.calcularTotalesDepositosRecibidos();
        if (declara == 1) {
          this.show();
        } else {
          this.log('Guardar Pago de Cliente u Otro');
          this.guardarPagos();
        }
      });
    });
  }

  setDefaultValues() {
    this.formRecibidoHeader.get('efectivo').setValue(this.resumen.efectivo_recaudado);
    this.formRecibidoHeader.get('dctoTransferencia').setValue(this.resumen.cantidad_transferencias);
    this.formRecibidoHeader.get('cheque').setValue(this.resumen.monto_cheque);
  }

  /********* DECLARACION RECIBIDO *********/
  agregarDepositoRecibido() {
    this.formValidatorsService.validateAllFormFields(this.formRecibidoDepositos);
    if (this.formRecibidoDepositos.invalid) return;

    // obtenre nombre banco
    const banco = this.optionsBancosEmpresa.find((p) => p.codigo === Number(this.formRecibidoDepositos.get('banco').value));
    if (!banco) {
      this.toastrService.error('Banco no encontrado');
      return;
    }

    this.listaDepositosRecibidos.push({
      monto: Number(this.formRecibidoDepositos.get('monto').value),
      numero_deposito: Number(this.formRecibidoDepositos.get('nroDeposito').value),
      // tipo_cuenta_bancaria_codigo
      banco_codigo: Number(this.formRecibidoDepositos.get('banco').value),
      banco_nombre: banco.nombre,
      numero_cuenta: this.formRecibidoDepositos.get('nroCuenta').value,
      fecha_deposito: this.formRecibidoDepositos.get('fecha').value,
    });
    this.listaDepositosRecibidos.map((deposito, index) => {
      deposito.index = index;
    });
    this.limpiarFormRecibidoDepositos();
    this.calcularTotalesDepositosRecibidos();
  }

  limpiarFormRecibidoDepositos() {
    this.formRecibidoDepositos.reset();
    // this.dtpFecha.clearDate()
    const now = this.datesService.CurrentDateToShortTimeString();
    this.formRecibidoDepositos.get('fecha').setValue(now);

    this.formRecibidoDepositos.markAsUntouched();
    this.formRecibidoDepositos.markAsPristine();
  }

  calcularTotalesDepositosRecibidos() {
    this.totalDepositosRecibidos = _.sumBy(this.listaDepositosRecibidos, 'monto');
    this.calcularTotalesRecibidos();
  }

  calcularTotalesRecibidos() {
    // let montoDiferencial = Number(this.formDiferencial.get('monto').value)
    // if (this.formDiferencial.get('cargoOrAbono').value === this.TIPO_CARGO)
    //   montoDiferencial *= -1

    // const montoCargoRuta = - Number(this.formCargoRuta.get('monto').value)

    this.totalRecibidos =
      Number(this.formRecibidoHeader.get('efectivo').value) +
      Number(this.formRecibidoHeader.get('dctoTransferencia').value) +
      Number(this.formRecibidoHeader.get('cheque').value) +
      Number(this.formCargoRuta.get('monto').value) +
      this.totalDepositosRecibidos;
    // + montoDiferencial
    // + montoCargoRuta

    const diferencia = this.totalRecibidos - this.resumen.total_resumen;
    if (diferencia > 0) {
      this.formDiferencial.get('cargoOrAbono').setValue(this.TIPO_ABONO);
      this.formDiferencial.get('monto').setValue(diferencia);
    } else {
      this.formDiferencial.get('cargoOrAbono').setValue(this.TIPO_CARGO);
      this.formDiferencial.get('monto').setValue(diferencia);
    }
    // TIPO_CARGO
  }

  eliminarDepositoRecibido({ index }) {
    this.listaDepositosRecibidos = this.listaDepositosRecibidos.filter((deposito) => deposito.index !== index);
    this.calcularTotalesDepositosRecibidos();
  }
  /********* DECLARACION RECIBIDO *********/

  guardarPagos() {
    this.log('guardar Pagos MainData', this.mainData);
    const depositoControlEfectivo = _.cloneDeep(this.listaDepositosRecibidos);
    depositoControlEfectivo.forEach((deposito) => {
      delete deposito.index;
      delete deposito.banco_nombre;
    });
    delete this.mainData.declaracionControl.clienteSeleccionado;
    const inputParams = {
      entidad: {
        declaracionControl: this.mainData.declaracionControl,
        // pagos: [
        //   {
        //     saldoDocumento: this.mainData.saldoDocumento,
        //     difereciaPago: this.mainData.difereciaPago,
        //     forma_pago: this.mainData.forma_pago,
        //     monto_coforme: this.mainData.monto_coforme,
        //   }
        // ],
        pagos: this.mainData.pagos,
        controlEfectivo: {
          rut_usuario: this.rutUsuario,
          monto_efectivo: Number(this.formRecibidoHeader.get('efectivo').value),
          monto_transferencia_recaudada: Number(this.formRecibidoHeader.get('dctoTransferencia').value),
          monto_cheque: Number(this.formRecibidoHeader.get('cheque').value),
          diferencia_tipo: this.formDiferencial.get('cargoOrAbono').value === this.TIPO_ABONO,
          motivo: this.formDiferencial.get('motivo').value,
          monto: Math.abs(Number(this.formDiferencial.get('monto').value)),
          motivo_cargo_transportista: this.formCargoRuta.get('motivo').value,
          monto_cargo_transportista: Number(this.formCargoRuta.get('monto').value),
        },
        depositoControlEfectivo,
      },
    };
    this.processing = true;
    //this.onProcessingChance.emit(true)

    this.log('guardarPagos', JSON.stringify(inputParams));

    this.pagoService.guardarPagos(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.processing = false;
        this.onProcessingChance.emit(false)
        return;
      }

      this.toastrService.success('Control efectivo realizado con éxito Nro. Pago ' + respuesta.pagos[0].forma_pago[0].codigo);
      this.onControlEfectivoRealizado.emit({
        input: inputParams,
        output: respuesta,
      });
      this.processing = false;
      //this.onProcessingChance.emit(false)
      this.hide();
    });
  }
}
